<template>
  <!--  急救车的历史轨迹-->
  <div>
    <my-dialog
      :is-show-footer="false"
      :dialog-carted="showDialog"
      :width="840"
      form-title="轨迹"
      @confirmOk="closeDialog"
    >
      <template #content>
        <trace-map/>
      </template>
    </my-dialog>
  </div>
</template>

<script>
import MyDialog from "@components/customDialog/MyDialog";
import TraceMap from "@components/MapContainer/TraceMap";

export default {
  name: "TraceShow",
  components: {
    MyDialog,
    TraceMap
  },
  props: {
    showDialog: {
      type: Boolean,
      default() {
        return false;
      }
    },
  },
  emits: ["closeDialog"],
  data() {
    return {};
  },
  methods: {
    closeDialog() {
      this.$emit("closeDialog");
    },
  }
};
</script>

<style scoped lang="scss">

</style>
